import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

const mowAppTheme = {
  dark: false,
  colors: {
    primary: '#2E7D32',
    'primary-darken-1': '#1B5E20',
    secondary: '#5D4037',
    'secondary-darken-1': '#3E2723',
    accent: '#66BB6A',
    success: '#43A047',
    info: '#1976D2',
    warning: '#FB8C00',
    error: '#E53935',
    background: '#F5F5F5',
    surface: '#FFFFFF',
  },
}

export default createVuetify({
  theme: {
    defaultTheme: 'mowAppTheme',
    themes: {
      mowAppTheme,
    },
  },
  defaults: {
    VCard: {
      rounded: 'lg',
      elevation: 1,
    },
    VBtn: {
      rounded: 'lg',
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
    },
  },
})
